module.exports = __webpack_public_path__ + "img/bottom_opening.6c13194c.png";